import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ToasterModule } from 'angular2-toaster/angular2-toaster';
import { BsModalModule } from 'ng2-bs3-modal';

import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { RatingModule } from 'ngx-bootstrap/rating';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { DatepickerModule } from 'ngx-bootstrap/datepicker';

import { FlotDirective } from './directives/flot/flot.directive';
import { SparklineDirective } from './directives/sparkline/sparkline.directive';
import { EasypiechartDirective } from './directives/easypiechart/easypiechart.directive';
import { ColorsService } from './colors/colors.service';
import { CheckallDirective } from './directives/checkall/checkall.directive';
import { VectormapDirective } from './directives/vectormap/vectormap.directive';
import { NowDirective } from './directives/now/now.directive';
import { ScrollableDirective } from './directives/scrollable/scrollable.directive';
import { JqcloudDirective } from './directives/jqcloud/jqcloud.directive';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { KeysPipe } from './pipes/keys.pipe';
import { CreatePaiementComponent } from './paiement/create/create.component';
import { ListPaiementComponent } from './paiement/list/list.component';
import { NgxResourceToolkit } from '@ngx-resource-toolkit/core';
import { ListFactureComponent } from './facture/list/list.component';
import { CreateFactureComponent } from './facture/create/create.component';
import { CalculMontantService } from './services/calcul-montant.service';
import { TabsComponent } from './tabs/tabs.component';
import { TabsService } from './services/tabs.service';
import { DisponibiliteComponent } from './disponibilite/disponibilite.component';
import { InfoFamilleComponent } from './famille/info/info.component';
import { ExportService } from './services/export.service';
import { FamilleService } from './services/famille.service';
import { OccupationComponent } from './occupation/occupation.component';
import { OccupationInputComponent } from './occupation/occupation-input.component';
import { SelectionComponent } from './miscellaneous/selection.component';
import { CoursFormComponent } from './cours/cours.component';
import { StoreService } from '@ngx-resource-toolkit/core';
import { LoaderComponent } from './miscellaneous/loader.component';
import { ModalConfirmationComponent } from './miscellaneous/modal-confirmation.component';
import { ErrorMessageService } from './services/error-message.service';
import { EleveService } from './services/eleve.service';
import { TableButtonsService } from './services/table-buttons.service';
import { CoursService } from './services/cours.service';
import { HabilitationService } from './services/habilitations.service';
import { PresentationComponent } from './presentation/presentation.component';
import { PhonePipe } from './pipes/phone.pipe';
import { EvaluationComponent } from './examen/evaluation/evaluation.component';
import { BulletinService } from './services/bulletin.service';
import { MonetairePipe } from './pipes/monetaire.pipe';
import { PaiementEditComponent } from './paiement/edit/edit.component';
import { SearchCoursComponent} from './cours/search-component/search-component.component';
import { TypeNotationPipe } from './pipes/type-notation.pipe';
import { InfoEleveComponent } from './eleve/info/info.component';
import { ResponsableInfoComponent } from './responsable/responsable-info/responsable-info.component';
import { AppSummernoteComponent } from './summernote/summernote.component';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
// import { NgAutoCompleteModule } from "ng-auto-complete";
// import { AutoCompleteModule } from 'ng5-auto-complete';
import { NgxMyDatePickerModule } from 'ngx-mydatepicker';
import { FamilleComponent } from './famille/search/search.component';
import { SearchCoursCollectifComponent } from './cours/search-cours-collectif/search-cours-collectif.component';
import { ShowCoursComponent } from './cours/show/show.component';

// https://angular.io/styleguide#!#04-10
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        RouterModule,
        AccordionModule.forRoot(),
        AlertModule.forRoot(),
        ButtonsModule.forRoot(),
        CarouselModule.forRoot(),
        CollapseModule.forRoot(),
        DatepickerModule.forRoot(),
        BsDropdownModule.forRoot(),
        ModalModule.forRoot(),
        PaginationModule.forRoot(),
        ProgressbarModule.forRoot(),
        RatingModule.forRoot(),
        TabsModule.forRoot(),
        TimepickerModule.forRoot(),
        TooltipModule.forRoot(),
        TypeaheadModule.forRoot(),
        ToasterModule.forChild(),
        NgxResourceToolkit,
        BsModalModule,
        NgxDatatableModule,
        NgxMyDatePickerModule.forRoot(),
        AutocompleteLibModule
    ],
    providers: [
        ColorsService,
        CalculMontantService,
        TabsService,
        ExportService,
        FamilleService,
        ErrorMessageService,
        EleveService,
        TableButtonsService,
        CoursService,
        HabilitationService,
        BulletinService,
        DatePipe,
    ],
    declarations: [
        FlotDirective,
        SparklineDirective,
        EasypiechartDirective,
        CheckallDirective,
        VectormapDirective,
        NowDirective,
        ScrollableDirective,
        JqcloudDirective,
        // NGX-AUTO
        KeysPipe,
        CreatePaiementComponent,
        ListPaiementComponent,
        ListFactureComponent,
        CreateFactureComponent,
        TabsComponent,
        DisponibiliteComponent,
        InfoFamilleComponent,
        FamilleComponent,
        OccupationComponent,
        OccupationInputComponent,
        SelectionComponent,
        CoursFormComponent,
        LoaderComponent,
        ModalConfirmationComponent,
        PresentationComponent,
        PhonePipe,
        EvaluationComponent,
        MonetairePipe,
        PaiementEditComponent,
        SearchCoursComponent,
        TypeNotationPipe,
        InfoEleveComponent,
        ResponsableInfoComponent,
        AppSummernoteComponent,
        SearchCoursCollectifComponent,
        ShowCoursComponent,
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        RouterModule,
        AccordionModule,
        AlertModule,
        ButtonsModule,
        CarouselModule,
        CollapseModule,
        DatepickerModule,
        BsDropdownModule,
        ModalModule,
        PaginationModule,
        ProgressbarModule,
        RatingModule,
        TabsModule,
        TimepickerModule,
        TooltipModule,
        TypeaheadModule,
        ToasterModule,
        FlotDirective,
        SparklineDirective,
        EasypiechartDirective,
        CheckallDirective,
        VectormapDirective,
        NowDirective,
        ScrollableDirective,
        JqcloudDirective,
        // LEA
        BsModalModule,
        CreatePaiementComponent,
        ListPaiementComponent,
        ListFactureComponent,
        TabsComponent,
        DisponibiliteComponent,
        InfoFamilleComponent,
        FamilleComponent,
        OccupationComponent,
        OccupationInputComponent,
        SelectionComponent,
        CoursFormComponent,
        LoaderComponent,
        ModalConfirmationComponent,
        PresentationComponent,
        // NGX-AUTO
        NgxResourceToolkit,
        // AutoLayoutComponent,
        // KeysPipe,
        // AutoTableComponent
        PhonePipe,
        TypeNotationPipe,
        EvaluationComponent,
        PaiementEditComponent,
        SearchCoursComponent,
        SearchCoursCollectifComponent,
        InfoEleveComponent,
        ResponsableInfoComponent,
        AppSummernoteComponent,
        ShowCoursComponent,
    ]
})

// https://github.com/ocombe/ng2-translate/issues/209
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [StoreService]
        };
    }
}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/shared.module.ts